import {appName} from '../settings/constants'
import {createSelector} from 'reselect'
import {Record} from 'immutable'
import RestService from '../helpers/RestService'
import {arrayToMap, arrayPrimitivesToMap, formatErrorMessage, sortCB} from '../helpers/common'
import {CATEGORIES_START, CATEGORIES_SUCCESS, MASS_CATEGORIES_SUCCESS, CATEGORIES_FAIL, CATEGORIES_ENTITIES_CHANGE, CATEGORIES_ENTITIES_DELETE, checkAndUploadCategories, setCategoriesCursor, uncheckCategories} from './categories'
import {SOURCES_START, SOURCES_SUCCESS, SOURCES_FAIL, SOURCES_ENTITIES_CHANGE, SOURCES_ENTITIES_DELETE, MASS_SOURCES_SUCCESS, checkAndUploadSources, clearSourcesCursor} from './sources'
import {TRASHED_QUESTIONS_RECOVER, checkAndUploadGeneralStatistic} from './questions'
import {DISABLED, ENABLED, _getId, _getIds, _trashedScopeCB, _isTrashed, _entities, _entitiesWithTrashed, _getEntity, _getEntityWithTrashed, adjustEntitiesFieldsType} from './_utils'
import { SubmissionError } from 'redux-form'
import {handleTutorialStart} from './tutorial'
import {setQbmNavItem, QBM_NAV_CATEGORIES} from './app'
import {ajaxUrls} from '../settings/routes'


/**
 * Constants
 * */

export const moduleName = 'subjects'
const prefix = `${appName}/${moduleName}`

export const SUBJECTS_START = `${prefix}/SUBJECTS_START`
export const SUBJECTS_SUCCESS = `${prefix}/SUBJECTS_SUCCESS`
export const SUBJECTS_FAIL = `${prefix}/SUBJECTS_FAIL`
export const SET_SUBJECTS_CURSOR = `${prefix}/SET_SUBJECTS_CURSOR`

export const SUBJECTS_ENTITIES_CHANGE = `${prefix}/SUBJECTS_ENTITIES_CHANGE`
export const SUBJECTS_ENTITIES_DELETE = `${prefix}/SUBJECTS_ENTITIES_DELETE`


/**
 * Reducer
 * */

const subjectRecord = Record({
    id : null,
    name : "",
    created_at : null,
    updated_at : null,
    status : ENABLED,

    categoriesIds : arrayPrimitivesToMap([]),
    categoriesLoaded : false,
    categoriesLoading : false,

    sourcesIds : arrayPrimitivesToMap([]),
    sourcesLoaded : false,
    sourcesLoading : false,

    /*trashedQuestionsIds : arrayPrimitivesToMap([]),
    trashedQuestionsLoaded : false,
    trashedQuestionsLoading : false,*/
})

const ReducerRecord = Record({
    entities : arrayToMap([], subjectRecord),
    loading : false,
    loaded : false,
    cursor : null,
    creating : false,
})

const defaultState = new ReducerRecord()

export const reducer = (state = defaultState, action) => {
    const {type, payload} = action

    switch (type) {
        case SUBJECTS_START : {
            return state.set('loading', true)
            break
        }
        case SUBJECTS_SUCCESS : {
            let {subjects} = payload
            return state.set('entities', arrayToMap(subjects, subjectRecord))
                .set('loading', false)
                .set('loaded', true)
            break
        }
        case SUBJECTS_FAIL : {
            return state.set('loading', false)
            break
        }
        case CATEGORIES_START : {
            let {subjectId} = payload
            return state.updateIn(['entities', subjectId], subject => subject.set("categoriesLoading", true))
            break
        }
        case CATEGORIES_SUCCESS : {
            let {subjectId, categories} = payload
            return state.updateIn(
                ['entities', subjectId], subject =>
                    subject.set("categoriesIds", arrayPrimitivesToMap(categories.map(category=>category.id)))
                            .set("categoriesLoaded", true)
                            .set("categoriesLoading", false)
            )
            break
        }
        case MASS_CATEGORIES_SUCCESS : {
            let {categoriesData} = payload
            categoriesData.forEach(cdItem => {
                let {subjectId, categories} = cdItem
                state = state.updateIn(
                    ['entities', subjectId], subject =>
                        subject.set("categoriesIds", arrayPrimitivesToMap(categories.map(category=>category.id)))
                )
            })
            return state
            break
        }
        case CATEGORIES_FAIL : {
            let {subjectId} = payload
            return state.updateIn(['entities', subjectId], subject => subject.set("categoriesLoading", false))
            break
        }
        case TRASHED_QUESTIONS_RECOVER : {
            let {subject_id} = payload
            return state.updateIn(['entities', subject_id], subject => subject.set('status', ENABLED))
            break
        }
        case SOURCES_START : {
            let {subjectId} = payload
            return state.updateIn(['entities', subjectId], subject => subject.set("sourcesLoading", true))
            break
        }
        case SOURCES_SUCCESS : {
            let {subjectId, sources} = payload
            return state.updateIn(
                ['entities', subjectId], subject =>
                    subject.set("sourcesIds", arrayPrimitivesToMap(sources.map(category=>category.id)))
                            .set("sourcesLoaded", true)
                            .set("sourcesLoading", false)
            )
            break
        }
        case MASS_SOURCES_SUCCESS : {
            let {sourcesData, loadState = false} = payload
            sourcesData.forEach(sdItem => {
                let {subjectId, sources} = sdItem
                state = state.updateIn(
                    ['entities', subjectId], subject => {
                        subject = subject.set("sourcesIds", arrayPrimitivesToMap(sources.map(category=>category.id)))
                        if (loadState) {
                            subject = subject.set("sourcesLoaded", true).set("sourcesLoading", false)
                        }
                        return subject
                    }
                )
            })
            return state
            break
        }
        case SOURCES_FAIL : {
            let {subjectId} = payload
            return state.updateIn(['entities', subjectId], subject => subject.set("sourcesLoading", false))
            break
        }
        case SET_SUBJECTS_CURSOR : {
            let {subjectId} = payload
            return state.set('cursor', subjectId)
            break
        }
        case SUBJECTS_ENTITIES_CHANGE : {
            const {subjects = []} = payload
            subjects.forEach(subject => {
                const {id} = subject
                state = state.setIn(["entities", id], new subjectRecord({...subject}))
            })
            return state
            break
        }
        case SUBJECTS_ENTITIES_DELETE : {
            const {ids = []} = payload
            ids.forEach(id => {
                state = state.updateIn(["entities", id], subject => subject.set('status', DISABLED))
                if (state.get("cursor") === id) {
                    state = state.set("cursor", null)
                }
            })
            return state
            break
        }
        case CATEGORIES_ENTITIES_CHANGE : {
            const {categories = [], subjectId} = payload
            return state.updateIn(['entities', subjectId], subject => {
                return subject.update("categoriesIds", categoriesIds => categoriesIds.merge(arrayPrimitivesToMap(categories.map(category=>category.id))))
            })
            break
        }
        /*case CATEGORIES_ENTITIES_DELETE : {
            const {ids = [], subjectId} = payload
            return state.updateIn(['entities', subjectId], subject => {
                ids.forEach(id => {
                    subject = subject.deleteIn(["categoriesIds", id])
                })
                return subject
            })
            break
        }*/
        case SOURCES_ENTITIES_CHANGE : {
            const {sources = [], subjectId} = payload
            return state.updateIn(['entities', subjectId], subject => {
                return subject.update("sourcesIds", sourcesIds => sourcesIds.merge(arrayPrimitivesToMap(sources.map(category=>category.id))))
            })
            break
        }
        case SOURCES_ENTITIES_DELETE : {
            const {ids = [], subjectId} = payload
            return state.updateIn(['entities', subjectId], subject => {
                ids.forEach(id => {
                    subject = subject.deleteIn(["sourcesIds", id])
                })
                return subject
            })
            break
        }
        default : {
            return state
            break
        }
    }
}


/**
 * Selectors
 * */

export const stateSelector = state => state[moduleName]
export const subjectsMapSelector = createSelector(stateSelector, state => state.entities)
export const subjectsSelector = createSelector(subjectsMapSelector, _entities)
export const subjectsWithTrashedSelector = createSelector(subjectsMapSelector, _entitiesWithTrashed)
export const subjectsLoadStateSelector = createSelector(stateSelector, state => ({loaded : state.loaded, loading : state.loading}))

export const subjectSelector = createSelector(subjectsMapSelector, _getId, _getEntity)
export const subjectWithTrashedSelector = createSelector(subjectsMapSelector, _getId, _getEntityWithTrashed)
export const createSubjectSelector = () => subjectSelector
export const createSubjectWithTrashedSelector = () => subjectWithTrashedSelector

export const subjectsCursorSelector = createSelector(stateSelector, state => state.cursor)
export const currentSubjectSelector = createSelector(subjectsMapSelector, subjectsCursorSelector, _getEntity)

export const firstOrderedSubjectSelector = createSelector(subjectsSelector, subjects => subjects.sort(sortCB)[0])

/**
 * Action Creators
 * */

export const setSubjectsCursor = (subjectId) => ({
    type : SET_SUBJECTS_CURSOR,
    payload : {
        subjectId
    }
})

export const changeSubjectsEntities = (subjects) => ({
    type : SUBJECTS_ENTITIES_CHANGE,
    payload : {
        subjects,
    }
})

export const deleteSubjectsEntities = (ids) => {
    return {
        type : SUBJECTS_ENTITIES_DELETE,
        payload : {
            ids
        }
    }
}


/**
 * Thunk
 * */

export const loadSubjects = () => {
    return (dispatch) => {
        dispatch({
            type : SUBJECTS_START,
        })
        RestService.customFetch(ajaxUrls.subjectList)
            .then(res => {
                if (res.status >= 400) throw new Error(res.statusText)
                return res.json()
            })
            .then(response => {
                let {errcode, subjects} = response
                if (errcode !== 200) throw new Error("Failed to fetch subjects") // TODO discuss possible messages from server

                dispatch({
                    type : SUBJECTS_SUCCESS,
                    payload : {
                        subjects : adjustEntitiesFieldsType(subjects),
                    }
                })

                dispatch(handleTutorialStart())
            })
            .catch(error => {
                dispatch({
                    type : SUBJECTS_FAIL,
                })
                console.warn(error) // TODO discuss with backend error handling
            })
    }
}

export const handleSubjectClick = (id) => (dispatch, getState) => {
    const state = getState()
    const subjectsCursor = subjectsCursorSelector(state)

    if (subjectsCursor !== id) {
        dispatch(setSubjectsCursor(id))
        dispatch(setCategoriesCursor(null))
        dispatch(checkAndUploadCategories(id))
        dispatch(checkAndUploadSources(id))
        dispatch(setQbmNavItem(QBM_NAV_CATEGORIES))
        dispatch(uncheckCategories())
        dispatch(clearSourcesCursor())
        dispatch(checkAndUploadGeneralStatistic(true))
    }else{
        dispatch(checkAndUploadSources(id))
        dispatch(checkAndUploadGeneralStatistic(true))
    }
}


/*
* Redux Form
* */

export const handleCreateSubject = (params) => {
    const {name} = params
    let data = new FormData()
    data.append('Branch', JSON.stringify({name}))
    return RestService.bodyAsFormData(ajaxUrls.subjectCreate, data)
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, subject, message} = res
            if (errcode === 200) {
                return {...subject, created_at : +subject.created_at, updated_at : +subject.updated_at}
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}

export const handleUpdateSubject = (params) => {
    const {id, name} = params
    let data = new FormData()
    data.append('Branch', JSON.stringify({id, name}))
    return RestService.bodyAsFormData(ajaxUrls.subjectUpdate, data)
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, subject, message} = res
            if (errcode === 200) {
                return {...subject, created_at : +subject.created_at, updated_at : +subject.updated_at}
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}

// TODO delete other data (categories, sources)
export const handleDeleteSubject = (params) => {
    const {id} = params
    return RestService.postFormData(ajaxUrls.subjectDelete, "Branch=" + JSON.stringify({id}))
        .then(res => {
            if (res.status >= 400) {
                throw new SubmissionError({
                    _error : res.statusText,
                })
            }
            return res.json()
        })
        .then(res => {
            let {errcode, id : deletedId, message} = res
            if (errcode === 200) {
                return deletedId
            } else {
                throw new SubmissionError({
                    _error : formatErrorMessage(message),
                })
            }
        })
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/subjects.js